// extracted by mini-css-extract-plugin
export default {"l":"_4a7ae5bc94"};